import React, { useState, useEffect } from "react";
import { Grid, Typography, Button } from "@mui/material";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../utils/token";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EditAutoAssign({ selectedRow,onClose }) {
    console.log("selectedRow", selectedRow);
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();

  // Lists
  const [campaignList, setCampaignList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [subServiceList, setSubserviceList] = useState([]);
  const [admissionProgramList, setAdmissionProgramList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [userList, setUserList] = useState([]);

  // Selected values
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [service, setService] = useState([]);
  const [serviceIds, setServiceIds] = useState([]);
  const [subService, setSubService] = useState([]);
  const [admissionProgram, setAdmissionProgram] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [assignTo, setAssignTo] = useState([]);

  // Percentages
  const [percentages, setPercentages] = useState({ assignment_percentage: selectedRow?.assignment_percentage||[] });

  console.log("percentages", percentages);
  // Changes to submit
  const [changes, setChanges] = useState({});

  // Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Show snackbar
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // ----------------- FETCH DATA -----------------

  // Campaign List
  useEffect(() => {
    const fetchCampaigns = async () => {
      const token = getTokenOrLogout();
      if (!token) return;

      try {
        const res = await fetch(`${API_ENDPOINT}route2.0/ongoing-upcomingevent/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch campaigns");
        const data = await res.json();
        setCampaignList(data);

        // Set selected campaign
        const sel = data.find((i) => i.id === selectedRow?.campaign_id?.id);
        setSelectedCampaign(sel);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCampaigns();
  }, []);

  // Service List
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}service`);
        if (!res.ok) throw new Error("Failed to fetch services");
        const data = await res.json();
        setServiceList(data);

        // Set selected services
        const selectedServices = data.filter((i) =>
          selectedRow?.service_id?.includes(i.service_name)
        );
        setService(selectedServices);
        setServiceIds(selectedServices.map((i) => i.id));
      } catch (err) {}
    };
    fetchServices();
  }, []);

  // SubService List
  useEffect(() => {
    const fetchSubservices = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}subservice`);
        if (!res.ok) throw new Error("Failed to fetch subservices");
        const data = await res.json();

        const filtered = data.filter((i) => serviceIds.includes(i.service_id));
        setSubserviceList(filtered);

        const selectedSub = filtered.filter((i) =>
          selectedRow?.sub_service_id?.includes(i.name)
        );
        setSubService(selectedSub);
      } catch (err) {}
    };
    if (serviceIds.length) fetchSubservices();
  }, [serviceIds]);

  // Admission Program List
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}subservice-program`);
        if (!res.ok) throw new Error("Failed to fetch programs");
        const data = await res.json();

        const subServiceIds = subService.map((i) => i.id);
        const filtered = data.filter((i) => subServiceIds.includes(i.sub_service_id));
        setAdmissionProgramList(filtered);

        const selectedPrograms = filtered.filter((i) =>
          selectedRow?.admission_program_id?.includes(i.name)
        );
        setAdmissionProgram(selectedPrograms);
      } catch (err) {}
    };
    if (subService.length) fetchPrograms();
  }, [subService]);

  // Branch List
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}branch`);
        if (!res.ok) throw new Error("Failed to fetch branches");
        const data = await res.json();
        setBranchList(data);

        const selectedBranches = data.filter((i) =>
          selectedRow?.nearest_branch_id?.includes(i.branch_name)
        );
        setBranchName(selectedBranches);
      } catch (err) {}
    };
    fetchBranches();
  }, []);

  // Users List
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (!res.ok) throw new Error("Failed to fetch users");
        const data = await res.json();
        const sorted = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setUserList(sorted);

        const selectedUsers = sorted.filter((i) =>
          selectedRow?.counsellor_id?.includes(i.first_name)
        );
        setAssignTo(selectedUsers);
      } catch (err) {}
    };
    fetchUsers();
  }, []);

  // ----------------- HANDLERS -----------------

  const handleFieldChange = (fieldName, value) => {
    setChanges((prev) => ({ ...prev, [fieldName]: value }));
  };

  const handleChangeCampaign = (e, value) => {
    setSelectedCampaign(value);
    handleFieldChange("campaign_id", value?.id);
  };

  const handleServiceChange = (e, value) => {
    setService(value);
    const ids = value.map((i) => i.id);
    setServiceIds(ids);
    handleFieldChange("service_id", ids);
  };

  const handleSubServiceChange = (e, value) => {
    setSubService(value);
    const ids = value.map((i) => i.id);
    handleFieldChange("sub_service_id", ids);
  };

  const handleAdmissionProgramChange = (e, value) => {
    setAdmissionProgram(value);
    const ids = value.map((i) => i.id);
    handleFieldChange("admission_program_id", ids);
  };

  const handleBranchChange = (e, value) => {
    setBranchName(value);
    const ids = value.map((i) => i.id);
    handleFieldChange("nearest_branch_id", ids);
  };

  const handleUserChange = (e, value) => {
    setAssignTo(value);
    const ids = value.map((i) => i.id);
    handleFieldChange("counsellor_id", ids);
    const apiFormat = ids.map((i) => ({ user_id: i, per: 0 }));
    setPercentages({ assignment_percentage: apiFormat });
    handleChangePercentage(value[0], 0);
  };

  // Handle percentage changes
 const handleChangePercentage = (user, per) => {
  setPercentages((prev) => {
    const oldList = prev.assignment_percentage || [];

    // Remove old entry for this user
    const filtered = oldList.filter(
      (item) => item.user_id?.id !== user.id
    );

    // Find old assigned value if exists
    const oldItem = oldList.find(
      (item) => item.user_id?.id === user?.id
    );

    const newItem = {
      per: Number(per),
      user_id: {
        id: user?.id,
        first_name: user?.first_name,
      },
      assigned: oldItem?.assigned || 0,
    };

    const updated = [...filtered, newItem];

    const assignToIds =assignTo.map((i) => i.id);
const finalAssignPercentageforBackend = updated.filter((item) => assignToIds.includes(item?.user_id?.id));

    const apiFormat = finalAssignPercentageforBackend.map((item) => ({
      per: item.per,
      user_id: item?.user_id?.id, // number only
      assigned: item.assigned,
    }));

    // Send to changes
    handleFieldChange(
      "assignment_percentage",
      (apiFormat)
    );

  
  

    return {
      assignment_percentage: updated,
    };
  });
};


  const handleReset = () => {
    setSelectedCampaign(null);
    setService([]);
    setSubService([]);
    setAdmissionProgram([]);
    setBranchName([]);
    setAssignTo([]);
    setPercentages({ assignment_percentage: [] });
    setChanges({});
  };

  const handleSubmit = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    if (!selectedCampaign) return showSnackbar("Please select a campaign", "error");
    if (!service.length) return showSnackbar("Please select a service", "error");
    if (!subService.length) return showSnackbar("Please select a sub service", "error");
    // if (!admissionProgram.length) return showSnackbar("Please select an admission program", "error");
    if (!branchName.length) return showSnackbar("Please select a branch", "error");
    if (!assignTo.length) return showSnackbar("Please select a user", "error");
    if (!percentages.assignment_percentage.length) return showSnackbar("Please select a percentage", "error");
    try {
      const res = await fetch(`${API_ENDPOINT}leaddistribution/${selectedRow?.id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...changes, user_id: parseInt(userId) }),
      });

      const data = await res.json();

      if (res.ok) {showSnackbar("Leads assigned successfully", "success")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }

      else showSnackbar(data.message || "Failed to assign leads", "error");
    } catch (err) {
      showSnackbar("Failed to assign leads", "error");
    }
  };

  // ----------------- RENDER -----------------

  return (
    <>
      <Grid container spacing={2}>
        {/* Campaign */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Select Campaign    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
          <CustomAutocompleteComp
            fullWidth
            size="small"
            value={selectedCampaign}
            onChange={handleChangeCampaign}
            options={campaignList}
            getOptionLabel={(option) => option?.campaign_name || ""}
            readOnly
          />
        </Grid>

        {/* Service */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Select Service    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
          <CustomAutocompleteComp
            size="small"
            multiple
            value={service}
            onChange={handleServiceChange}
            options={serviceList}
            getOptionLabel={(option) => option.service_name}
            tooltipContent={(option) => option.service_name}
          />
        </Grid>

        {/* SubService */}
        {service.length > 0 && (
          <Grid item xs={12} sm={6}>
            <Typography variant="h6">Sub Service    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
            <CustomAutocompleteComp
              size="small"
              multiple
              value={subService}
              onChange={handleSubServiceChange}
              options={subServiceList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
            />
          </Grid>
        )}

        {/* Admission Program */}
        {service.length > 0 &&
          subService.length > 0 &&
          subService.some((val) => [13, 14].includes(val.id)) &&
          service.some((val) => val.id === 2) && (
            <Grid item xs={12} sm={6}>
              <Typography variant="h6">Admission Program</Typography>
              <CustomAutocompleteComp
                size="small"
                multiple
                value={admissionProgram}
                onChange={handleAdmissionProgramChange}
                options={admissionProgramList}
                getOptionLabel={(option) => option.name}
                tooltipContent={(option) => option.name}
              />
            </Grid>
          )}

        {/* Branch */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Select Nearest Branch    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
          <CustomAutocompleteComp
            size="small"
            multiple
            value={branchName}
            onChange={handleBranchChange}
            options={branchList}
            getOptionLabel={(option) => option?.branch_name || ""}
            tooltipContent={(option) => option?.branch_name || ""}
          />
        </Grid>

        {/* Users */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Select Users    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
          <CustomAutocompleteComp
            size="small"
            multiple
            value={assignTo}
            onChange={handleUserChange}
            options={userList}
            getOptionLabel={(option) =>
              `${option.first_name || ""} ${option.last_name || ""}`
            }
            tooltipContent={(option) =>
              `${option.first_name || ""} ${option.last_name || ""}`
            }
          />
        </Grid>

        {/* Percentage Inputs */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {assignTo.map((user) => {
              const current = percentages.assignment_percentage?.find(
                (item) => item.user_id?.id === user.id
              )?.per;

              return (
                <Grid item xs={12} md={6} key={user.id}>
                  <Typography variant="h5" sx={{ mb: 0.5 }}>
                    {user?.first_name} {user?.last_name}    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
                  </Typography>
                  <CustomTextFieldComp
                    type="number"
                    size="normal"
                    fullWidth
                    placeholder="Enter percentage"
                    inputProps={{ min: 0, max: 100 }}
                    value={current || ""}
                    onChange={(e) =>
  handleChangePercentage(user, Number(e.target.value))
}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} mt={2}>
          <Grid container gap={2} justifyContent="flex-end">
            <Button
              variant="contained"
              color="error"
              onClick={onClose}
              sx={{ borderRadius: "5px" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ borderRadius: "5px" }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
